import configuration from '../../utilities/configuration';
import * as PaymentEffectUtility from "../../utilities/PaymentEffectUtility";
import * as EffectUtility from "../../utilities/EffectUtility";
import CustomerModel from "../../models/payment/CustomerModel";
import PaymentModel from "../../models/payment/PaymentModel";
import PaymentStatusModel from "../../models/payment/PaymentStatusModel";

export async function paymentCustomer(customer) {
    const endpoint = configuration.paymentCustomerUrl;
    return PaymentEffectUtility.postCustomerToUnzer(CustomerModel, endpoint, customer);
}

export async function paymentCharge(paymentInfo) {
    const endpoint = configuration.apiServer + configuration.apiPaymentsPath + "/charges";
    return EffectUtility.postToModel(PaymentModel, endpoint, paymentInfo);
}

export async function checkStatusPayment(paymentId) {
    const endpoint = configuration.apiServer + configuration.apiPaymentsPath + "/" + paymentId + "/charges";
    return EffectUtility.getToModel(PaymentStatusModel, endpoint, true, true);
}